import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

/**
 * Custom node for collapsed external dependencies/dependents
 * Shows a count and can be clicked to expand the list
 */
function ExternalNode({ data, selected }) {
  const isOutgoing = data.direction === 'outgoing';
  const externalPaths = data.externalPaths || [];

  return (
    <div className={`graph-node external-node ${isOutgoing ? 'outgoing' : 'incoming'} ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} />
      <div className="node-icon">
        {isOutgoing ? (
          // Outgoing arrow (dependencies)
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M7 17L17 7"/>
            <polyline points="7 7 17 7 17 17"/>
          </svg>
        ) : (
          // Incoming arrow (dependents)
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 7L7 17"/>
            <polyline points="17 17 7 17 7 7"/>
          </svg>
        )}
      </div>
      <div className="node-content">
        <div className="node-label">{data.label}</div>
        {externalPaths.length > 0 && (
          <div className="external-preview">
            {externalPaths.slice(0, 3).map((ep, i) => (
              <span key={i} className="external-item" title={ep.path}>
                {ep.name}
              </span>
            ))}
            {externalPaths.length > 3 && (
              <span className="external-more">+{externalPaths.length - 3} more</span>
            )}
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

export default memo(ExternalNode);
